import { AgsAccountsButtonControlFactory } from "ags/controls/factories/ags-accounts-button-control-factory";
import { AgsAutoSpinsCountRadioControlFactory } from "ags/controls/factories/ags-auto-spins-count-radio-control-factory";
import { AgsAutoStopControlFactory } from "ags/controls/factories/ags-auto-stop-control-factory";
import { AgsAutoplayStartButtonControlFactory } from "ags/controls/factories/ags-autoplay-start-button-control-factory";
import { AgsBetButtonControlFactory } from "ags/controls/factories/ags-bet-button-control-factory";
import { AgsBetSliderControlFactory } from "ags/controls/factories/ags-bet-slider-control-factory";
import { AgsCreditSizeLimitSliderControlFactory } from "ags/controls/factories/ags-credit-size-slider-control-factory";
import { AgsCreditSizeStepperControlFactory } from "ags/controls/factories/ags-credit-size-stepper-control-factory";
import { AgsDepositButtonControlFactory } from "ags/controls/factories/ags-deposit-button-control-factory";
import { AgsHomeButtonControlFactory } from "ags/controls/factories/ags-home-button-control-factory";
import { AgsLineButtonControlFactory } from "ags/controls/factories/ags-line-button-control-factory";
import { AgsMaxBetButtonControlFactory } from "ags/controls/factories/ags-max-bet-button-control-factory";
import { AgsSingleWinLimitSliderControlFactory } from "ags/controls/factories/ags-single-win-limit-slider-control-factory";
import { AgsStopOnFeatureControlFactory } from "ags/controls/factories/ags-stop-on-feature-control-factory";
import { AgsTotalCreditsRadioControlFactory } from "ags/controls/factories/ags-total-credits-radio-control-factory";
import { AgsTotalCreditsTextControlFactory } from "ags/controls/factories/ags-total-credits-text-control-factory";
import { AgsTotalLossLimitSliderControlFactory } from "ags/controls/factories/ags-total-loss-limit-slider-control-factory";
import { AgsTotalStakeTextControlFactory } from "ags/controls/factories/ags-total-stake-text-control-factory";
import { AgsTotalWinLimitSliderControlFactory } from "ags/controls/factories/ags-total-win-limit-slider-control-factory";
import { ButtonElement } from "appworks/graphics/elements/button-element";
import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { AutoStopControlFactory } from "appworks/ui/factories/autoplay/auto-stop-control-factory";
import { GetAutoplayFactories } from "appworks/ui/factories/get-autoplay-factories";
import { GetStandardFactories } from "appworks/ui/factories/get-standard-factories";
import { HamburgerToggleControlFactory } from "appworks/ui/factories/standard/hamburger-toggle-control-factory";
import { TotalStakeTextControlFactory } from "appworks/ui/factories/standard/total-stake-text-control-factory";
import { UIFlagState } from "appworks/ui/flags/ui-flag-state";
import { UIFlag, uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { UI } from "appworks/ui/ui";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { JurisdictionService } from "slotworks/services/jurisdiction/jurisdiction-service";

export function AgsSetupUI(): void {
    // Button styles
    ButtonElement.DISABLED_TINT = 0xA9A9A9;
    ButtonElement.OVER_TINT = 0xd3d3d3;
    ButtonElement.DOWN_SCALE = 0.95;

    // UI layers
    const betBarScenes = {
        base: gameiomModel.displayCurrency ? "base_currency" : "base",
        freespins: gameiomModel.displayCurrency ? "freespins_currency" : "freespins"
    };

    UI.layer(Layers.get("Skip"), [
        {
            scene: "skip",
            show: new UIFlagState(UIFlag.ALWAYS, UIFlag.IDLE),
            enable: new UIFlagState(UIFlag.ALWAYS, UIFlag.NO_SKIP | UIFlag.MIN_SPIN_COOLDOWN | UIMenuFlag.PAYTABLE | UIMenuFlag.AUTO)
        }
    ]);

    UI.layer(Layers.get("BetBar"), [
        {
            scene: betBarScenes.freespins,
            enable: new UIFlagState(UIFlag.ALWAYS, UIFlag.FREE_SPINS | UIFlag.AUTO_SPIN | UIMenuFlag.PAYTABLE | UIFlag.EXTERNAL_DISABLE | UIFlag.FREE_BETS),
            show: UIFlagState.FREESPINS
        },
        {
            scene: betBarScenes.base,
            enable: new UIFlagState(UIFlag.IDLE, UIFlag.PROMPT | UIFlag.AUTO_SPIN | UIMenuFlag.PAYTABLE | UIFlag.EXTERNAL_DISABLE | UIFlag.FREE_BETS),
            show: new UIFlagState(UIFlag.ALWAYS, UIMenuFlag.PAYTABLE)
        }
    ]);

    UI.layer(Layers.get("HamburgerMenu"), [
        {
            scene: betBarScenes.freespins,
            enable: new UIFlagState(UIFlag.ALWAYS, UIFlag.PROMPT | UIMenuFlag.PAYTABLE | UIFlag.EXTERNAL_DISABLE),
            show: UIFlagState.FREESPINS
        },
        {
            scene: betBarScenes.base,
            enable: new UIFlagState(UIFlag.ALWAYS, UIFlag.PROMPT | UIMenuFlag.PAYTABLE | UIFlag.EXTERNAL_DISABLE),
            show: new UIFlagState(UIFlag.ALWAYS, UIMenuFlag.PAYTABLE)
        }
    ]);

    let autoEnableCondition = new UIFlagState(UIFlag.ALWAYS, UIFlag.BONUS | UIFlag.EXTERNAL_DISABLE);

    if (!Services.get(JurisdictionService).getSpinSkippingEnabled()) {
        autoEnableCondition = new UIFlagState(UIFlag.ALWAYS, UIFlag.BONUS | UIFlag.NO_SKIP | UIFlag.EXTERNAL_DISABLE);
    }

    const autoplayEnabled = Services.get(JurisdictionService).getAutoplayEnabled();
    const freespinsSmartbutton = autoplayEnabled ? "freespins" : "freespins_noauto";
    const skipSmartbutton = autoplayEnabled ? "skip" : "skip_noauto";
    const baseSmartbutton = autoplayEnabled ? "base" : "base_noauto";

    const smartButtonUiScenes = [
        {
            scene: "auto",
            enable: autoEnableCondition,
            show: new UIFlagState(UIFlag.AUTO_SPIN, UIFlag.BONUS | UIFlag.FREE_SPINS)
        },
        {
            scene: freespinsSmartbutton,
            enable: new UIFlagState(UIFlag.FREE_SPINS, UIFlag.BONUS | UIFlag.EXTERNAL_DISABLE | UIFlag.NO_SKIP | UIMenuFlag.AUTO),
            show: UIFlagState.FREESPINS
        },
        {
            scene: baseSmartbutton,
            show: new UIFlagState(UIFlag.IDLE, UIMenuFlag.PAYTABLE),
            enable: new UIFlagState(UIFlag.IDLE,
                UIFlag.MIN_SPIN_COOLDOWN |
                UIFlag.NO_SKIP |
                UIFlag.REPLAY |
                UIMenuFlag.AUTO |
                UIFlag.GAMBLE_UI |
                UIFlag.AWAITING_RESPONSE |
                UIFlag.EXTERNAL_DISABLE |
                UIFlag.BIG_WIN |
                UIFlag.BIG_WIN_DELAY)
        },
        {
            scene: skipSmartbutton,
            show: new UIFlagState(UIFlag.ALWAYS, UIMenuFlag.PAYTABLE),
            enable: new UIFlagState(UIFlag.ALWAYS,
                UIFlag.NO_SKIP |
                UIFlag.BONUS |
                UIFlag.EXTERNAL_DISABLE |
                UIFlag.GAME_IN_PROGRESS |
                UIFlag.BIG_WIN_DELAY)
        }
    ];

    UI.layer(Layers.get("SmartButton"), smartButtonUiScenes);

    const paytableFlagState = new UIFlagState(UIMenuFlag.PAYTABLE);
    const menuFlagState = new UIFlagState(UIMenuFlag.MENU);
    const betMenuFlagState = new UIFlagState(UIMenuFlag.STAKE);
    const autoplayFlagState = new UIFlagState(UIMenuFlag.AUTO);

    UI.layer(Layers.get("MenusContent"), [
        {
            scene: "autoplay_ukgc",
            enable: new UIFlagState(UIFlag.ALWAYS, UIFlag.FREE_SPINS | UIFlag.PROMPT | UIFlag.EXTERNAL_DISABLE),
            show: autoplayFlagState
        },
        {
            scene: "betsetting",
            enable: UIFlagState.ALWAYS,
            show: betMenuFlagState
        },
        {
            scene: "general",
            enable: new UIFlagState(UIFlag.ALWAYS, UIFlag.FREE_SPINS | UIFlag.PROMPT | UIFlag.EXTERNAL_DISABLE),
            show: menuFlagState
        },
        {
            scene: "paytable",
            enable: new UIFlagState(UIFlag.ALWAYS, UIFlag.FREE_SPINS | UIFlag.PROMPT | UIFlag.EXTERNAL_DISABLE),
            show: paytableFlagState
        }
    ]);

    UI.layer(Layers.get("Header"), [
        {
            scene: "base",
            enable: UIFlagState.ALWAYS,
            show: new UIFlagState(UIFlag.ALWAYS, UIMenuFlag.PAYTABLE)
        }
    ]);

    uiFlags.hook(autoplayFlagState).on.add(() => gameWrapper.autospinDialogueOpened());
    uiFlags.hook(autoplayFlagState).off.add(() => gameWrapper.autospinDialogueClosed());
    uiFlags.hook(betMenuFlagState).on.add(() => gameWrapper.betDialogueOpened());
    uiFlags.hook(betMenuFlagState).off.add(() => gameWrapper.betDialogueClosed());
    uiFlags.hook(menuFlagState).on.add(() => gameWrapper.menuDialogueOpened());
    uiFlags.hook(menuFlagState).off.add(() => gameWrapper.menuDialogueClosed());
    uiFlags.hook(paytableFlagState).on.add(() => gameWrapper.paytableDialogueOpened());
    uiFlags.hook(paytableFlagState).off.add(() => gameWrapper.paytableDialogueClosed());

    // Buttons
    UI.button(Layers.get("SmartButton"), "autoplay", UIMenuFlag.AUTO);
    UI.button(Layers.get("HamburgerMenu"), "ui_paytable", UIMenuFlag.PAYTABLE);
    UI.button(Layers.get("BetBar"), "ui_bet_button", UIMenuFlag.STAKE);
    UI.button(Layers.get("HamburgerMenu"), "ui_settings", UIMenuFlag.MENU);
    UI.button(Layers.get("MenusContent"), "help", UIMenuFlag.PAYTABLE);
    UI.button(Layers.get("MenusContent"), "close", 0);

    // Controls
    UI.register(
        ...getStandardFactories(),
        ...getAutoplayFactories(),
        new AgsTotalCreditsRadioControlFactory(),
        new AgsTotalCreditsTextControlFactory(),
        new AgsSingleWinLimitSliderControlFactory(),
        new AgsTotalWinLimitSliderControlFactory(),
        new AgsTotalStakeTextControlFactory(),
        new AgsTotalLossLimitSliderControlFactory(),
        new AgsAutoplayStartButtonControlFactory(),
        new AgsHomeButtonControlFactory(),
        new AgsAccountsButtonControlFactory(),
        new AgsMaxBetButtonControlFactory(),
        new AgsDepositButtonControlFactory(),
        new AgsStopOnFeatureControlFactory(),
        new AgsAutoStopControlFactory(),
        new AgsAutoSpinsCountRadioControlFactory(),
        new AgsBetSliderControlFactory(),
        new AgsBetButtonControlFactory(),
        new AgsLineButtonControlFactory()
    );
        
    if (!gameiomModel.hideDenom) {
        UI.register(
            new AgsCreditSizeStepperControlFactory(),
            new AgsCreditSizeLimitSliderControlFactory(),
        );
    }

    if (gameiomModel.hideBet) {
        UI.register(
            gameiomModel.displayCurrency ? 
                new AgsTotalStakeTextControlFactory() : 
                new AgsTotalCreditsTextControlFactory()
        );
    } else {
        UI.register(
            new AgsTotalStakeTextControlFactory(), 
            new AgsTotalCreditsTextControlFactory(),
        );
    }

    UI.init();
}

function getAutoplayFactories() {
    const autoplayFactories = GetAutoplayFactories();
    const factoriesToExclude = [
        AutoStopControlFactory
    ];

    const factories = autoplayFactories.filter((factory) => factoriesToExclude.every((excludedFactory) => {
        return !(factory instanceof excludedFactory);
    }));

    return factories;
}

function getStandardFactories() {
    const standardFactories = GetStandardFactories();
    const factoriesToExclude = [
        TotalStakeTextControlFactory
    ];

    const factories = standardFactories.filter((factory) => factoriesToExclude.every((excludedFactory) => {
        return !(factory instanceof excludedFactory);
    }));

    return factories;
}
